<template>
  <div class="picmanger">
    <div class="header">
      <div style="display: flex; align-items: center">
        <img
          src="@/assets/house/breadicon.png"
          style="margin-right: 10px"
          alt
        />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>数智中心</el-breadcrumb-item>
          <el-breadcrumb-item>数据分析</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh" class="refresh">
        <img
          :class="isRefresh ? 'imgmove' : ''"
          width="16px"
          height="16px"
          src="@/assets/house/refresh.png"
          alt
        />
        <p>刷新</p>
      </div>
    </div>

    <div class="main" v-loading="isRefresh">
      <div class="head">
        <h4>数据分析</h4>
      </div>

      <div class="tablebg">
        <div style="width: 100%; height: 100%">
          <div class="number">
            <div class="mainnumber">
              <div
                v-for="(e, i) in numberList"
                :key="i"
                class="mainpic"
                style="position: relative;"
              >
              <img  :src="require(`../../../../assets/house/gpic${i+1}.png`)" alt="">
              <div style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;z-index: 2;">
                <div class="text">{{ e.text }}</div>
                
                <div  class="num">
                  <vns class="num-text" :start="0" :end="e.num" :times="26" :speed="50"></vns>
                  <div style="line-height: 70px;">{{ e.numre }}</div>
                </div>
              </div>
              <!-- :style="{ background: 'url(' + e.src + ')' }" -->
                <!-- <p>{{ e.text }}</p>
                <div style="display: flex">
                  <p>
                    <vns :start="0" :end="e.num" :times="26" :speed="50"></vns>
                  </p>
                  <p>{{ e.numre }}</p>
                </div> -->
              </div>
            </div>
          </div>
          <div class="echarts">
            <div class="headernumber">
              <div class="xian"></div>
              <h4>资源入库趋势</h4>
            </div>

            <div class="mainecharts">
              <div class="pictable">
                <data-echarts :yAxisDocumentarySum='pictureInsertCount' :xAxisDataOfht='xAxisDataOfht' :otherInsertCount='otherInsertCount' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vns from 'vue-number-scroll'
import { getOverview } from '@/api/resourceLog'
import { dataecharts } from '@/components/index'
import {DISKSTORAGE} from '@/config/index'
import { formatConversion } from '@/plugins/getdate'
export default {
  components:{
    'vns':vns,
    'data-echarts':dataecharts
  },
  data() {
    return {
      formatConversion,
      isRefresh:false,
      //info:[],
      xAxisDataOfht:[],
      pictureInsertCount:[],
      otherInsertCount:[],

      atlasCount:'',
      libCount: '',
      pictureActivityCount:'',
      pictureCount: '',
      pictureDownloadCount: '',
      pictureShareCount: '',
      pictureSizeCount: '',
      userCount: '',

      numberList: [
        // 资源库  资源集  图片数 图片总大小 图片被下载次数 视频数  视频总大小  视频被下载次数  用户数
        {
          num: 0,
          text: '资源库数',
          propName:'libCount'
        },
        {
          num: 0,
          text:'资源集数',
          propName:'atlasCount'
        },
        {
          num: 0,
          text:'图片数',
          propName:'pictureCount'
        },
        {
          num: 0,
          text: '图片总大小',
          numre:'GB',
          propName:'pictureSizeCount'
        },
        {
          num: 0,
          text:'图片被下载次数',
          propName:'pictureDownloadCount'
        },
        {
          num: 0,
          text:'视频数',
          propName:'videoCount'
        },
        {
          num: 0,
          text: '视频总大小',
          numre:'GB',
          propName:'videoSizeCount'
        },
        {
          num: 0,
          text:'视频被下载次数',
          propName:'videoDownloadCount'
        },
        {
          num: 100,
          text:'用户数',
          propName:'userCount'
        },
        {
          num: 0,
          text: '系统使用情况',
          numre:'%',
          propName:'dataUse'
        },

        // {
        //   src: require("@/assets/house/gpic5.png"),
        //   num: 0,
        //   text: "图片数",
        // },
        // {
        //   src: require("@/assets/house/gpic5.png"),
        //   num: 0,
        //   text: "视频数",
        // },
        // {
        //   src: require("@/assets/house/gpic6.png"),
        //   num: 0,
        //   numre: "GB",
        //   text: "资源总大小",
        // },
        // {
        //   src: require("@/assets/house/gpic7.png"),
        //   num: 0,
        //   text: "图片被分享次数",
        // },
        // {
        //   src: require("@/assets/house/gpic8.png"),
        //   num: 0,
        //   text: "资源被下载次数",
        // },
        // {
        //   src: require("@/assets/house/gpic1.png"),
        //   num: 0,
        //   text: "资源库数量",
        // },
        // {
        //   src: require("@/assets/house/gpic2.png"),
        //   num: 0,
        //   // numre:'GB',
        //   text: "资源集数量",
        // },
        // {
        //   src: require("@/assets/house/gpic3.png"),
        //   num: 0,
        //   text: "用户数",
        // },
        // {
        //   src: require("@/assets/house/gpic4.png"),
        //   num: 0,
        //   text: "累计征稿活动",
        // },
        
        
        
      ],
    };
  },
  methods: {
    //获取echarts资源
    async getOverviewasync(){
     let { data } = await getOverview()
     data.pictureSizeCount = parseFloat((data.pictureSizeCount / 1024 / 1024  / 1024).toFixed(2))
     data.videoSizeCount = parseFloat((data.videoSizeCount / 1024 / 1024  / 1024).toFixed(2))
      // console.log('已用内存大小',data.pictureSizeCount+data.videoSizeCount);
      let totalUse =parseFloat(100 *(data.pictureSizeCount+data.videoSizeCount)/(DISKSTORAGE * 1024))
      // console.log(totalUse);
  
      data.dataUse = totalUse>0.01?parseFloat(totalUse.toFixed(2)):parseFloat(totalUse.toFixed(4))
      
      // let dataUse= ((100 * totalUse / (DISKSTORAGE * 1024)).toFixed(4));

      // data.dataUse
      this.pictureInsertCount = []
      this.otherInsertCount = []
      this.xAxisDataOfht = []
     for(let i=0;i<data.tendency.length;i++){
      let time_zj =this.formatConversion(data.tendency[i].date.toString()).substring(0,10)
        this.pictureInsertCount.push(data.tendency[i].pictureInsertCount) //图片次数
        this.otherInsertCount.push(data.tendency[i].videoInsertCount)//其它图片次数
        this.xAxisDataOfht.push(time_zj)     //日期
     }
      //数据分析
      this.numberList.forEach((ele) => {
        // console.log(ele.propName);
        for (let key in data) {
          if (data.hasOwnProperty(key)) { // 过滤掉原型链上的属性
            // console.log(key);
            if (ele.propName==key) {
              ele.num = data[key]
            }
          }
        }
      })
    //  this.numberList[0].num = data.pictureCount,
    //  this.numberList[1].num = data.pictureCount,
    //  this.numberList[2].num = (data.pictureSizeCount / 1024 / 1024  / 1024).toFixed(2),
    //  this.numberList[3].num = data.pictureShareCount,
    //  this.numberList[3].num = data.pictureDownloadCount,
    //  this.numberList[4].num = data.libCount,
    //  this.numberList[5].num = data.atlasCount,
    //  this.numberList[6].num = data.userCount,
    //  this.numberList[7].num = data.pictureActivityCount,
    
      
      this.isRefresh = false
    },

    //刷新表格
    refresh() {
      this.isRefresh = true;
      setTimeout(() => {
        this.isRefresh = false;
        this.getOverviewasync()
      }, 888);
    },
  },
  created() {
      
    this.isRefresh = true
    this.getOverviewasync()
  },
  beforeDestroy() {
    // 组件销毁前调用
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./dataanalysis.scss";
</style>
